import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ResourceLoading } from "../../../components/utils/ResourceLoading";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { deleteOfferAsync, getOfferAsync } from "../../../slices/offer";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { FolderIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Notes } from "../../../components/dashboard/notes/notes";
import { dispatchWithToast } from "../../../components/Utils";
import ProConfirmation from "../../../components/utils/ProConfirmation";
import { OrderStatus } from "../../../components/dashboard/orders/utils";
import { ResourceError } from "../../../components/utils/ResourceError";
import { OfferInfo } from "../../../components/dashboard/offers/offer-info";

export const Offer = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const itemState = {
    ...useSelector((store) => {
      return store.offers;
    }),
  };
  const { isLoading, error, errors, offer } = itemState;
  const [deletePromptOpen, setDeletePromptOpen] = useState(false);

  useEffect(() => {
    dispatch(getOfferAsync(id));
  }, [dispatch, id]);

  const handleDeletePrompt = () => {
    setDeletePromptOpen(true);
  };

  const navigate = useNavigate();

  const handleAfterDispatch = () => {
    setDeletePromptOpen(false);
    // Redirect to offers page
    navigate("/dashboard/offers");
  };

  const handleDeleteItem = () => {
    dispatchWithToast(dispatch(deleteOfferAsync(offer?.id)), null, () =>
      handleAfterDispatch(false)
    );
  };

  const headerMeta = [
    {
      component: <OrderStatus order={offer} />,
      label: "Status",
      description: "",
      path: null,
      action: null,
      icon: null,
      hidden: false,
    },
  ];

  const headerActions = [
    {
      component: (
        <div className="px-2 mt-2">
          <Notes module={"offer"} module_param={offer?.id} />
        </div>
      ),
      label: "Status",
      description: "",
      path: null,
      action: null,
      icon: null,
      textColor: "text-teal-700",
      bgColor: "bg-red-200",
      hidden: false,
      menu: false,
    },
    {
      component: null,
      label: "Kopier tilbud",
      description: "",
      path: null,
      // action: () => handleDeletePrompt(order),
      icon: FolderIcon,
      textColor: "text-teal-700",
      bgColor: "",
      hidden: isLoading,
      menu: true,
    },
    {
      component: null,
      label: "Slett tilbud",
      description: "",
      path: null,
      action: () => handleDeletePrompt(offer),
      icon: TrashIcon,
      textColor: "text-teal-700",
      bgColor: "",
      hidden: offer?.invoice?.id || isLoading,
      menu: true,
    },
  ];

  const renderContent = () => {
    if (isLoading) {
      return <ResourceLoading />;
    }
    if (error && errors) {
      <ResourceError errors={errors} />;
    }

    return (
      <Grid container spacing={3}>
        <Grid
          container
          item
          lg={12}
          spacing={3}
          sx={{ height: "fit-content", order: { md: 2, xs: 1 } }}
        >
          <Grid item xs={12}>
            <OfferInfo offer={offer} />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <DashboardHeader
        subtitle=""
        actions={headerActions}
        title={offer?.id ? offer?.displayTitle : "New Offer"}
        meta={headerMeta}
        // mainButton={{
        //   label: "New",
        //   action: () => setCaseDialogOpen(true),
        //   path: null,
        //   color: "",
        //   icon: PlusIcon,
        // }}
      >
        <div className="mx-auto mt-8 grid max-w-none grid-cols-1 gap-6 sm:px-6 lg:grid-flow-col-dense lg:grid-cols-3 lg:px-8">
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
            {renderContent()}
          </div>
        </div>
      </DashboardHeader>

      <ProConfirmation
        severity="confirmation"
        open={deletePromptOpen}
        message={
          "Dette tilbudet vil bli fjernet for godt og kan ikke reverseres"
        }
        action="delete"
        module="offer"
        // item_id={confirmation.item_id}
        yesCallback={() => handleDeleteItem()}
        cancelCallback={() => setDeletePromptOpen(false)}
      />
    </>
  );
};
